const GATEWAY_NUVEI = {id: 'nuvei', name: 'Nuvei'};
const GATEWAY_ZEN = {id: 'zen', name: 'Zen'};
const GATEWAY_PAYMENTIQ = {id: 'paymentiq', name: 'PaymentIQ'};
const GATEWAY_BTCD = {id: 'btcdirect', name: 'BTC Direct'};
const GATEWAY_PAYGATE10 = {id: 'paygate10', name: 'Paygate 10'};
const GATEWAY_PAYADMIT = {id: 'payadmit', name: 'Payadmit'};

const GATEWAYS_LIST_FULL = [GATEWAY_ZEN, GATEWAY_NUVEI, GATEWAY_BTCD, GATEWAY_PAYMENTIQ];
const GATEWAYS_LIST_ZEN = [GATEWAY_ZEN, GATEWAY_PAYMENTIQ];
const GATEWAYS_LIST_NUVEI = [GATEWAY_NUVEI, GATEWAY_PAYMENTIQ];
const GATEWAYS_LIST_PAYGATE10 = [GATEWAY_PAYGATE10];

const PAYMENT_METHODS = {
  openBanking: {
    name: 'Open Banking',
    icon: require('./icons/OpenBanking'),
    gatewaysList: [GATEWAY_NUVEI]
  },
  mastercard: {
    name: 'Mastercard',
    icon: require('./icons/Mastercard'),
    gatewaysList: [...GATEWAYS_LIST_FULL, GATEWAY_PAYADMIT]
  },
  visa: {
    name: 'Visa',
    icon: require('./icons/Visa'),
    gatewaysList: [...GATEWAYS_LIST_FULL, GATEWAY_PAYADMIT]
  },
  applepay: {
    name: 'Apple Pay',
    icon: require('./icons/ApplePay'),
    gatewaysList: [...GATEWAYS_LIST_FULL, GATEWAY_PAYADMIT]
  },
  googlepay: {
    name: 'Google Pay',
    icon: require('./icons/GooglePay'),
    gatewaysList: [GATEWAY_NUVEI, GATEWAY_ZEN, GATEWAY_PAYMENTIQ],
  },
  sofort: {
    name: 'Sofort',
    icon: require('./icons/Sofort'),
    gatewaysList: [GATEWAY_ZEN, GATEWAY_BTCD]
  },
  trustly: {
    name: 'Trustly',
    icon: require('./icons/Trustly'),
    gatewaysList: GATEWAYS_LIST_ZEN
  },
  iDeal: {
    name: 'iDeal',
    icon: require('./icons/Ideal'),
    gatewaysList: [GATEWAY_ZEN, GATEWAY_BTCD]
  },
  blik: {
    name: 'Blik',
    icon: require('./icons/Blik'),
    gatewaysList: GATEWAYS_LIST_ZEN
  },
  bancontact: {
    name: 'Bancontact',
    icon: require('./icons/Bancontact'),
    gatewaysList: [GATEWAY_ZEN, GATEWAY_BTCD]
  },
  bankTransfer: {
    name: 'Manual bank transfer',
    icon: require('./icons/ManualBankTransfer'),
    gatewaysList: [GATEWAY_ZEN, GATEWAY_BTCD]
  },
  eps: {
    name: 'EPS',
    icon: require('./icons/EPS'),
    gatewaysList: GATEWAYS_LIST_ZEN
  },
  giropay: {
    name: 'GiroPay',
    icon: require('./icons/Giropay'),
    gatewaysList: GATEWAYS_LIST_ZEN
  },
  upi: {
    name: 'UPI',
    gatewaysList: GATEWAYS_LIST_PAYGATE10
  },
  upiQrCode: {
    name: 'UPI QR Code',
    gatewaysList: GATEWAYS_LIST_PAYGATE10
  },
  netbanking: {
    name: 'Netbanking',
    gatewaysList: GATEWAYS_LIST_PAYGATE10
  }
}

const PAYMENT_METHODS_LIST = Object.keys(PAYMENT_METHODS).map((id) => {
  const data = PAYMENT_METHODS[id] || {};
  return {id, ...data};
});

const PAYMENT_METHODS_LIST_WITH_NO_GATEWAY = PAYMENT_METHODS_LIST.map((method) => {
  const nextMethod = {...method};
  nextMethod['gatewaysList'] = [{id: 'none', name: 'None'}, ...method['gatewaysList']];
  return nextMethod;
});

const PAYMENT_METHODS_FILTER_TABLE_HEAD = {
  name: 'payment_method',
  list: [{id: 'all', name: 'All'}, ...PAYMENT_METHODS_LIST]
}

module.exports = {
  PAYMENT_METHODS,
  PAYMENT_METHODS_LIST,
  PAYMENT_METHODS_LIST_WITH_NO_GATEWAY,
  PAYMENT_METHODS_FILTER_TABLE_HEAD,
  GATEWAYS_LIST_FULL
}
